export class OtherPrices {
    constructor(form) {
        this.totalMonthlyPaymentsInput = form.querySelector(".js-total-monthly-payments");
        this.priceElementInput = form.querySelector(".js-price");
        this.totalPriceElement = form.querySelector(".js-total-price");
        this.totalHoursInput = form.querySelector(".js-total-hours");
        this.pricePerHourElement = form.querySelector(".js-hourly-price");
        this.productSelect = form.querySelector(".js-product");
        this.userPriceElement = form.querySelector(".js-user-price");
        this.centerElement = form.querySelector(".js-center");
        this.centerPriceWrapper = form.querySelector(".js-center-price-wrapper");
        this.totalMonthlyPaymentsInput.addEventListener("change", this.calculatePrice.bind(this));
        this.priceElementInput.addEventListener("change", this.calculatePrice.bind(this));
        this.totalHoursInput.addEventListener("change", this.calculatePrice.bind(this));
        this.productSelect.addEventListener("change", this.calculatePrice.bind(this));
        this.centerElement.addEventListener("change", this.calculatePrice.bind(this));
        $(".js-product").on("change", this.calculatePrice.bind(this));
        this.calculatePrice();
    }
    calculatePrice() {
        this.setUserPrice();
        this.setTotalPrice();
        this.setHourlyPrice();
        this.setCenterPrice();
    }
    setUserPrice() {
        const { userPrice } = this;
        this.userPriceElement.textContent = this.numberToString(userPrice);
    }
    numberToString(value, precission = 0) {
        precission = 10 ** precission;
        return isNaN(value) || value <= 0
            ? "-"
            : (Math.round(value * precission) / precission).toString();
    }
    get userPrice() {
        const centerPrice = parseFloat(this.priceElementInput.value);
        const commission = (this.commissionPercent * centerPrice) / (100 - this.commissionPercent);
        return centerPrice + commission;
    }
    get commissionPercent() {
        const [productSelect] = this.productSelect.selectedOptions;
        if (!productSelect) {
            return 0;
        }
        const { commissionPercent } = productSelect.dataset;
        return Math.min(99, parseInt(commissionPercent));
    }
    setHourlyPrice() {
        const totalHours = parseInt(this.totalHoursInput.value);
        const pricePerHour = this.totalPrice / totalHours;
        this.pricePerHourElement.textContent = this.numberToString(pricePerHour, 2);
    }
    setTotalPrice() {
        this.totalPriceElement.textContent = this.numberToString(this.totalPrice);
    }
    get totalPrice() {
        const totalMonthlyPayments = parseInt(this.totalMonthlyPaymentsInput.value);
        return totalMonthlyPayments * this.userPrice;
    }
    static create(form) {
        return new OtherPrices(form);
    }
    setCenterPrice() {
        const basePrice = parseFloat(this.priceElementInput.value);
        const centerCommissionPercentage = this.centerCommissionPercentage();
        if (centerCommissionPercentage === 0) {
            this.centerPriceWrapper.classList.add("hidden");
            return;
        }
        this.centerPriceWrapper.classList.remove("hidden");
        const commission = parseFloat(((centerCommissionPercentage * basePrice) / 100).toFixed(2));
        this.centerPriceWrapper.querySelector(".js-center-price").textContent =
            this.numberToString(basePrice - commission, 2);
    }
    centerCommissionPercentage() {
        const selectCenterOption = this.centerElement.selectedOptions[0];
        if (!selectCenterOption) {
            return 0;
        }
        const { commissionPercentage } = selectCenterOption.dataset;
        return Math.min(99, parseInt(commissionPercentage));
    }
}
